<template>
  <component :is="landingComponent" />
</template>

<script>
import { PRODUCT_CODES } from '~/constants';
export default {
  layout: (context) => {
    return context.env.PRODUCT_NAME == PRODUCT_CODES.psh
      ? 'x-onboarding'
      : 'x-dashboard';
  },
  computed: {
    landingComponent() {
      const landingPage =
        this.$productName == PRODUCT_CODES.avcwise
          ? 'AvcLandingPage'
          : this.$productName == PRODUCT_CODES.psh
          ? 'PshLandingPage'
          : 'LandingPage';
      console.log(landingPage);
      return () => import(`~/components/DashboardPages/${landingPage}.vue`);
    }
  }
};
</script>
